import React from 'react';
import Button from "components/CustomButtons/Button.jsx";
import {
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from "@material-ui/core";
import classNames from "classnames";
import { appConstants } from "../../_constants";
import { withStyles } from "@material-ui/core/styles";
import CustomInput from "../../components/CustomInput/CustomInput";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

const StyledInput = withStyles({
    formControl: {
        margin: 0
    }
})(CustomInput)

const styles2 = {
  
    paragraph: {
        color: '#999999',
        fontFamily: 'Poppins',
        textAlign: 'left',
        margin: 0,
        fontSize: '0.85em'
    },
    headerContainer: {
        display: 'flex',
        padding: '10px 0',
        justifyContent: 'space-around'
    }
};

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    input: {
        marginTop: "0 !important"
    },
    nb: {
        color: "red",
        fontSize: "12px"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: "67%"
    },
    root: {
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "100%"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {
        marginTop: "0px",
        width: '100%'
    },
    icon: {
        margin: "8px 0px 8px 0px",
        position: "relative",
        top: "7px",
        paddingLeft: "8px",
    }
});

const renderApprovalFormView = (values, key) => {
    return (
        (typeof values[0] === 'object') ? (
            values.map(value => {
                return renderObjectView(value)
            })
        ) : (
                renderStringView(values, key)
            )
    );
}

const renderStringView = (values, valueKey) => {
    return (
        <Grid item md={12}>
            <CustomInput
                style={{ marginTop: "0px" }}
                // className={classNames(classes.input)}
                required
                labelText={valueKey}
                formControlProps={{
                    fullWidth: true
                }}
                inputProps={
                    {
                        type: "text",
                        value: values
                    }}
            />
        </Grid>
    )
}

const renderObjectView = (valueObject) => {
    let valueKeys = Object.keys(valueObject)
    return (
        <Card>
            <CardHeader color="regional" stats icon>
            <div style={styles2.headerContainer}>
                {valueKeys.map(valueKey => {
                    return (
                        <div style={styles.paragraph}>
                        <CustomInput
                            labelText={valueKey}
                            inputProps={{
                                type: "text",
                                value: valueObject[valueKey]
                            }}
                            formControlProps={{
                                fullWidth: true
                            }}
                        />
                        </div>
                    )
                })}
                </div>
            </CardHeader>
        </Card>
    )
}

const ViewTemplate = (props) => {
    const { record, handleChange, Comment, payload, isModalOpen,
        closeModal, classes, user, handleApproval,
        makerCheckerApprovalId, makerCheckerRejectionId,disabled } = props;

    const payloadKeys = Object.keys(payload);

    return (
        <div>
            < Dialog
                fullWidth={true}
                maxWidth={'md'}
                open={isModalOpen}
                onClose={closeModal}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: appConstants.REGIONAL_COLOR}}>
                    <span style={{ color: "white", textTransform: "uppercase" }}> Approval Form </span>
                </DialogTitle>
                <DialogContent style={{ marginTop: "20px" }}>
                    <Grid container spacing={24}>
                        {
                            payloadKeys.map((item, key) => {
                                const inputValue = payload[item];
                                return renderApprovalFormView(inputValue, item)     
                            })
                        }
                        {
                            record.StatusId !== appConstants.MAKER_CHECKER_STATUS.PENDING
                            &&
                            <Grid item md={12}>
                                <StyledInput
                                    style={{ marginTop: "0px" }}
                                    className={classNames(classes.input)}
                                    required
                                    labelText={"Comment"}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={
                                        {
                                            type: "text",
                                            value: record.Comment,
                                            name: "Comment",

                                        }}
                                />
                            </Grid>
                        }
                        {
                            record.StatusId === appConstants.MAKER_CHECKER_STATUS.PENDING
                            &&
                            <Grid item md={12}>
                                <StyledInput
                                    style={{ marginTop: "0px" }}
                                    className={classNames(classes.input)}
                                    required
                                    labelText={"Comment"}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={
                                        {
                                            type: "text",
                                            name: "Comment",
                                            onChange: handleChange
                                        }}
                                />
                                {!Comment &&
                                    <span style={{ color: 'red' }}>{"Comment is required"}</span>
                                }
                            </Grid>
                        }
                    </Grid>
                </DialogContent>
                <DialogActions>
                    {
                        (record &&
                            record.StatusId === appConstants.MAKER_CHECKER_STATUS.PENDING &&
                            record.CreatedBy === user.userName
                        ) &&
                        <div>
                            <p style={{ color: '#333' }}>Record is pending</p>
                        </div>
                    }
                    {
                        (record &&
                            record.StatusId === appConstants.MAKER_CHECKER_STATUS.PENDING &&
                            record.CreatedBy !== user.userName
                        ) &&
                        <div>
                            <Button disabled={disabled} color="regional" onClick={(e) => handleApproval(makerCheckerApprovalId)} autoFocus>
                                Approve
                                </Button>
                            <Button disabled={disabled} color="danger" onClick={(e) => handleApproval(makerCheckerRejectionId)}>
                                Reject
                                </Button>
                        </div>
                    }
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default (withMobileDialog()(withStyles(styles)(ViewTemplate)));

/* Written with love by Juliet April 2019*/


// WEBPACK FOOTER //
// ./src/Regional-Views/MakerChecker/viewTemplate.js